// extracted by mini-css-extract-plugin
module.exports = {"cancel_page":"cancelPage_cancel_page__i_2nc","cancel_icon":"cancelPage_cancel_icon__8Zr4F","cancel_text":"cancelPage_cancel_text__w0_xb"};